import { apiClient } from './api';
import { NotifyTemplateType, CommonState } from '@erpgold/shared';

export { NotifyTemplateType, CommonState };

export const TEMPLATE_PARAMS: Record<string, string> = {
  customer_name: 'Tên khách hàng',
  customer_phone: 'Số điện thoại',
  customer_email: 'Email khách hàng',
  order_id: 'ID đơn hàng',
  order_code: 'Mã đơn hàng',
  order_total: 'Tổng tiền đơn hàng',
  product_name: 'Tên sản phẩm',
  product_code: 'Mã sản phẩm',
  store_name: 'Tên cửa hàng',
  tenant_name: 'Tên đơn vị',
  created_at: 'Ngày tạo',
  updated_at: 'Ngày cập nhật',
};

export interface NotifyTemplate {
  _id: string;
  title: string;
  notify_title: string;
  content: string;
  code: string;
  type: NotifyTemplateType;
  state: CommonState;
  tenant_id?: string;
  extra: Record<string, unknown>;
  created_at: string;
  updated_at: string;
  created_by?: string;
  updated_by?: string;
}

export interface CreateNotifyTemplateDto {
  title: string;
  notify_title?: string;
  content: string;
  code?: string;
  type?: NotifyTemplateType;
  state?: CommonState;
  tenant_id?: string;
  extra?: Record<string, unknown>;
}

export interface UpdateNotifyTemplateDto {
  title?: string;
  notify_title?: string;
  content?: string;
  code?: string;
  type?: NotifyTemplateType;
  state?: CommonState;
  tenant_id?: string;
  extra?: Record<string, unknown>;
}

export interface QueryNotifyTemplateDto {
  page?: number;
  limit?: number;
  type?: string;
  state?: number;
  search?: string;
  sort?: string;
  order?: 'asc' | 'desc';
}

export interface NotifyTemplatesResponse {
  data: NotifyTemplate[];
  meta: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export const notificationTemplateService = {
  getNotificationTemplates: async (filters: QueryNotifyTemplateDto = {}): Promise<NotifyTemplatesResponse> => {
    const response = await apiClient.get('/notification-templates', { params: filters });
    return response.data.data;
  },

  getNotificationTemplateStats: async (): Promise<{ total: number; active: number; inactive: number }> => {
    const response = await apiClient.get('/notification-templates/stats');
    return response.data.data;
  },

  getNotificationTemplateById: async (id: string): Promise<NotifyTemplate> => {
    const response = await apiClient.get(`/notification-templates/${id}`);
    return response.data.data;
  },

  createNotificationTemplate: async (data: CreateNotifyTemplateDto): Promise<NotifyTemplate> => {
    const response = await apiClient.post('/notification-templates', data);
    return response.data.data;
  },

  updateNotificationTemplate: async (id: string, data: UpdateNotifyTemplateDto): Promise<NotifyTemplate> => {
    const response = await apiClient.put(`/notification-templates/${id}`, data);
    return response.data.data;
  },

  deleteNotificationTemplate: async (id: string): Promise<void> => {
    await apiClient.delete(`/notification-templates/${id}`);
  },

  deleteManyNotificationTemplates: async (ids: string[]): Promise<void> => {
    await apiClient.delete('/notification-templates', { data: { ids } });
  },

  cloneNotificationTemplate: async (id: string): Promise<NotifyTemplate> => {
    const response = await apiClient.post(`/notification-templates/clone/${id}`);
    return response.data.data;
  },
};

export default notificationTemplateService;